import { render, staticRenderFns } from "./FacePersonAddSelect.vue?vue&type=template&id=00f20468"
import script from "./FacePersonAddSelect.vue?vue&type=script&lang=js"
export * from "./FacePersonAddSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports